const BYTES_PER_MB = 1024 * 1024;
const DECIMAL_PLACES = 1;

export type FileValidationResult = {
  valid: boolean;
  error?: string;
  errorCode?: 'INVALID_TYPE' | 'INVALID_CONTENT' | 'INVALID_SIZE';
};

const CSV_MIME_TYPES = ['text/csv', 'text/plain', 'application/vnd.ms-excel'];

export const validateCsvFileType = (file: File): boolean => {
  const fileMimeType = file.type.toLowerCase();
  return CSV_MIME_TYPES.includes(fileMimeType);
};

export const validateCsvFile = async (
  file: File,
  maxFileSizeBytes?: number,
): Promise<FileValidationResult> => {
  if (!validateCsvFileType(file)) {
    return {
      valid: false,
      error: `Invalid file type: ${file.type}. Expected CSV file.`,
      errorCode: 'INVALID_TYPE',
    };
  }

  if (file.size === 0) {
    return {
      valid: false,
      error: 'CSV file is empty',
      errorCode: 'INVALID_SIZE',
    };
  }

  if (maxFileSizeBytes && file.size > maxFileSizeBytes) {
    const maxSizeMB = (maxFileSizeBytes / BYTES_PER_MB).toFixed(DECIMAL_PLACES);
    const fileSizeMB = (file.size / BYTES_PER_MB).toFixed(DECIMAL_PLACES);
    return {
      valid: false,
      error: `File size (${fileSizeMB}MB) exceeds maximum allowed size of ${maxSizeMB}MB`,
      errorCode: 'INVALID_SIZE',
    };
  }

  return { valid: true };
};
